/** Maximum photos on academy / organization public profile galleries. */
export const MAX_GALLERY_PHOTOS = 8;
